import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/LogoPlain.png'


const _hoisted_1 = {
  id: "header",
  class: "header d-flex align-items-center fixed-top"
}
const _hoisted_2 = { class: "container position-relative d-flex align-items-center justify-content-between" }
const _hoisted_3 = {
  id: "navmenu",
  class: "navmenu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { path: '/' },
        class: "logo d-flex align-items-center me-auto me-xl-0"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "MatrixHub Company Limited"
          }, null, -1),
          _createElementVNode("h1", { class: "sitename" }, "MatrixHub Co. Ltd.", -1)
        ])),
        _: 1,
        __: [2]
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMobileNav && _ctx.closeMobileNav(...args)))
        }, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/",
              class: _normalizeClass(_ctx.linkClass('/'))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Home")
              ])),
              _: 1,
              __: [3]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: _normalizeClass(_ctx.linkClass('/about'))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("About")
              ])),
              _: 1,
              __: [4]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/how-we-work",
              class: _normalizeClass(_ctx.linkClass('/how-we-work'))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("How we Work!")
              ])),
              _: 1,
              __: [5]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/who-we-serve",
              class: _normalizeClass(_ctx.linkClass('/who-we-serve'))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Who We Serve")
              ])),
              _: 1,
              __: [6]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/services",
              class: _normalizeClass(_ctx.linkClass('/services'))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Services")
              ])),
              _: 1,
              __: [7]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/products",
              class: _normalizeClass(_ctx.linkClass('/products'))
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Products")
              ])),
              _: 1,
              __: [8]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/team",
              class: _normalizeClass(_ctx.linkClass('/team'))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Team")
              ])),
              _: 1,
              __: [9]
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: _normalizeClass(_ctx.linkClass('/contact'))
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Contact")
              ])),
              _: 1,
              __: [10]
            }, 8, ["class"])
          ])
        ]),
        _createElementVNode("i", {
          class: _normalizeClass(["mobile-nav-toggle d-xl-none bi", _ctx.isMobileNavActive ? 'bi-x' : 'bi-list']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
        }, null, 2)
      ])
    ])
  ]))
}